const DeleteData = () => {
  return (
    <div>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSff1H6X3hKqcqdPYcNRpmL2klymzwTix6MGBQx5mIwlRiqy6w/viewform?embedded=true"
        width="100%"
        // height="100v"
        style={{ overflow: "hidden", height: "100vh" }}
        frameborder="0"
        marginheight="0"
        marginwidth="0"
      >
        Loading…
      </iframe>
    </div>
  );
};

export default DeleteData;
